import React, { PropsWithChildren, useEffect, useState } from "react";
import { useAuth } from "../resources/AuthProvider";
import { useNavigate } from "react-router";
import { checkAccess } from "../API/checkAccess";
import AcessoNegado from "../components/pages/AcessoNegado/AcessoNegado";

interface ProtectedRouteProps extends PropsWithChildren {
  url: string;
  superUserOnly?: boolean;
  requirePermissionCheck?: boolean;
}

const ProtectedRoute = ({
  children,
  url,
  requirePermissionCheck = true,
}: ProtectedRouteProps): JSX.Element => {
  const { isAuthenticated, userType } = useAuth();
  const { requiresPasswordChange } = useAuth();
  const navigate = useNavigate();
  const [isAllowed, setIsAllowed] = useState<boolean | null>(null);
  const [shouldRedirectToLogin, setShouldRedirectToLogin] = useState(false);

  useEffect(() => {
    const validateAccess = async () => {
      const token = sessionStorage.getItem("authToken");

      if (!token || !isAuthenticated()) {
        setShouldRedirectToLogin(true);
        return;
      }

      if (requiresPasswordChange && url !== "/alterar-senha-obrigatoria") {
        navigate("/alterar-senha-obrigatoria", { replace: true });
        return;
      }

      if (!requirePermissionCheck) {
        setIsAllowed(true);
        return;
      }

      const allowed = await checkAccess(token, url, userType());

      setIsAllowed(allowed);
    };

    validateAccess();
  }, [url, isAuthenticated, navigate, requirePermissionCheck, requiresPasswordChange, userType]);

  useEffect(() => {
    if (shouldRedirectToLogin) {
      navigate("/login", { replace: true });
    }
  }, [navigate, shouldRedirectToLogin]);

  if (isAllowed === null) {
    return <div>Carregando...</div>;
  }

  if (!isAllowed) {
    return <AcessoNegado />;
  }

  return children as JSX.Element;
};

export default ProtectedRoute;
